/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PairingCompletionResponse { 
    /**
     * OAuth App Client ID
     */
    client_id: string;
    /**
     * OAuth App Client secret
     */
    client_secret: string;
    /**
     * Org Id
     */
    org_id: string;
    /**
     * Provider ID in format: <res-type>-<res-id>
     */
    provider_id: string;
    /**
     * The endpoint for an Agent to authenticate at
     */
    auth_endpoint: string;
}

